// Presentation metadata for testimonials — kept separate from i18n string dict
// because these fields are language-independent (initials, gradient, employer favicon).
// Student headshots are intentionally not sourced from third-party sites (kikicentre.com
// hotlink-blocks, and using stock/random photos with real names would misrepresent).
// If the client shares official headshots, drop them into /public/testimonials/{key}.jpg
// and set `photo: "/testimonials/{key}.jpg"`. The Testimonials component prefers `photo`
// when present, otherwise renders the initials + gradient avatar.

export const TESTIMONIAL_MEDIA = [
  {
    key: "gurjeet",
    initials: "GS",
    // Warm sunrise — Mechatronics graduate energy
    gradient: "linear-gradient(135deg, #F97316 0%, #FBBF24 50%, #FFCC00 100%)",
    ink: "#0A0A0A",
    photo: null,
    employer: {
      short: "Atma Autotech",
      badge: "AA",
      badgeBg: "#0A0A0A",
      badgeInk: "#FFCC00",
      // Atma has no reliable public favicon; render styled badge
      logo: null,
    },
  },
  {
    key: "arun",
    initials: "AK",
    gradient: "linear-gradient(135deg, #0EA5E9 0%, #6366F1 55%, #8B5CF6 100%)",
    ink: "#F5F5F0",
    photo: null,
    employer: {
      short: "IFB Industries",
      badge: "IFB",
      badgeBg: "#003C71",
      badgeInk: "#ffffff",
      // IFB's official domain — Google's favicon service returns a real logo
      logo: "https://www.google.com/s2/favicons?domain=ifbindustries.com&sz=128",
    },
  },
  {
    key: "vicky",
    initials: "VK",
    gradient: "linear-gradient(135deg, #DC2626 0%, #F97316 60%, #FBBF24 100%)",
    ink: "#F5F5F0",
    photo: null,
    employer: {
      short: "IFB Industries",
      badge: "IFB",
      badgeBg: "#003C71",
      badgeInk: "#ffffff",
      logo: "https://www.google.com/s2/favicons?domain=ifbindustries.com&sz=128",
    },
  },
  {
    key: "kanwaljeet",
    initials: "KS",
    // German-flag inspired
    gradient: "linear-gradient(135deg, #050505 0%, #DC2626 55%, #FBBF24 100%)",
    ink: "#F5F5F0",
    photo: null,
    employer: {
      short: "HWK Koblenz",
      badge: "HK",
      badgeBg: "#1a3a8a",
      badgeInk: "#ffffff",
      // KIKI already ships the HWK partner mark — reuse it
      logo: null,
    },
  },
  {
    key: "ashish",
    initials: "AS",
    gradient: "linear-gradient(135deg, #10B981 0%, #06B6D4 55%, #6366F1 100%)",
    ink: "#F5F5F0",
    photo: null,
    employer: {
      short: "Boston Scientific",
      badge: "BS",
      badgeBg: "#0057B8",
      badgeInk: "#ffffff",
      logo: "https://www.google.com/s2/favicons?domain=bostonscientific.com&sz=128",
    },
  },
  {
    key: "jeslin",
    initials: "JM",
    gradient: "linear-gradient(135deg, #7C3AED 0%, #EC4899 55%, #F97316 100%)",
    ink: "#F5F5F0",
    photo: null,
    employer: {
      short: "KIKI · Soft Skills",
      badge: "KIKI",
      badgeBg: "#FFCC00",
      badgeInk: "#0A0A0A",
      // Reuse the KIKI logo already in public
      logo: "/kiki-logo.png",
    },
  },
];
